import React, { ReactNode } from 'react';

import { MessagingCampaignsListItemFragment } from '@occc/graphql';
import { StatusChip, TableCell, TableRow } from '@occc-app/design-system';

import { formatScheduledDate } from '../messaging-campaigns-list.utils';
import { chipVariantByStatus, titleByStatus } from '../messaging-campaigns-list.constants';
import { getMessagingCampaignTypeTitle } from '../../../messaging-center.utils';

export type MessagingCampaignsListItemProps = {
  campaign: MessagingCampaignsListItemFragment;
  onClick?: (
    campaign: MessagingCampaignsListItemFragment,
    event: React.MouseEvent<HTMLTableRowElement, MouseEvent>,
  ) => void;
  contextMenu: ReactNode;
};

export const MessagingCampaignsListItem = (props: MessagingCampaignsListItemProps) => {
  const { campaign, onClick, contextMenu } = props;

  const onTableRowClick = onClick
    ? (event: React.MouseEvent<HTMLTableRowElement, MouseEvent>) => {
        onClick(campaign, event);
      }
    : undefined;

  return (
    <TableRow onClick={onTableRowClick}>
      <TableCell>{campaign.title}</TableCell>
      <TableCell>{campaign.description}</TableCell>
      <TableCell>{getMessagingCampaignTypeTitle({ channels: campaign.channelsConfig })}</TableCell>
      <TableCell>{formatScheduledDate(campaign.scheduleAt)}</TableCell>
      <TableCell>
        <StatusChip
          label={titleByStatus[campaign.status]}
          variant={chipVariantByStatus[campaign.status]}
        />
      </TableCell>
      <TableCell align='right'>{contextMenu}</TableCell>
    </TableRow>
  );
};
